"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1508208/img/ballet_dancers_performance.png)]" aria-hidden="true">
        <div className="absolute inset-0 bg-dark-background/50"></div>
      </div>

      {}
      <div ref={ref} className={`relative z-10 max-w-4xl mx-auto px-6 text-center transition-all duration-200 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`}>
        <h1 className="text-5xl sm:text-6xl lg:text-7xl font-display font-bold text-foreground-dark mb-4 leading-tight">
          Professional Ballet Education<br />at an International Standard
        </h1>
        <p className="text-lg sm:text-xl text-foreground-dark/90 mb-8 max-w-2xl mx-auto font-sans">
          Structured, curriculum-based classical ballet training for students from beginner to advanced levels in Tujunga, California.
        </p>
        <Link to="#programs">
          <Button size="lg" className="transition-transform duration-120 ease-in-out hover:scale-102 hover:bg-accent-hover">
            Explore Our Programs
          </Button>
        </Link>
      </div>
    </section>;
}